<app-diagnostic-report
  *ngIf="openDiagnosticReport"
  [diagnosticReportWorksheetModels]="diagnosticReportWorksheetModels"
  [diagnosticReport]="diagnosticReport"
  [selectedMismatchedRecordSummary]="selectedMismatchedRecordSummary"
  [diagnosticReportSelectedRecordInfo]="diagnosticReportSelectedCellInfo"
  [hideDiagnosticReportDescription$]="hideDiagnosticReportDescription$"
  (selectedWorksheetNameEvent$)="onSelectedWorksheetName($event)"
  (selectedMismatchedRecordEvent$)="onSelectedMismatchedRecordEvent($event)"
  (hideDiagnosticReportDescriptionEvent$)="onHideDiagnosticReportDescription($event)">
</app-diagnostic-report>
<app-diagnostic-report-mismatched-record-details
  *ngIf="!openDiagnosticReport"
  (showReport$)="onShow($event)"
  (navigateToSource$)="onNavigateToSource($event)"
  [scenarioId]="diagnosticReport.scenarioId"
  [scenarioType]="diagnosticReport.scenarioType"
  [countryCode]="diagnosticReport.countryCode"
  [selectedWorksheetName]="diagnosticReportSelectedCellInfo.worksheetName"
  [recordModelSummary]="selectedMismatchedRecordSummary">
</app-diagnostic-report-mismatched-record-details>
<!--
[ngClass]="{'d-r-showed': openDiagnosticReport, 'd-r-hidden': !openDiagnosticReport}"-->
